import { useView } from "aurelia-templating";

@useView('views/plugins/onboarding-requests/generic-plugin/landing-pages/default/complete-request-pages/default/default.html')
export class Default {

    isRejected: boolean = window["onboardingRequestUrlMeta"].isRejected;
    title: boolean = window["onboardingRequestUrlMeta"].rejectedTitle;
    reason: boolean = window["onboardingRequestUrlMeta"].rejectedReason;

}